import { render, staticRenderFns } from "./PublicatorTab.vue?vue&type=template&id=bc56e656&scoped=true"
import script from "./PublicatorTab.vue?vue&type=script&lang=js"
export * from "./PublicatorTab.vue?vue&type=script&lang=js"
import style0 from "./PublicatorTab.vue?vue&type=style&index=0&id=bc56e656&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc56e656",
  null
  
)

export default component.exports